<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row>
            <a-col>
              <label for="">当前打开人：客服1；客户2；</label>
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px;">
            <a-col :span="5" style="display: flex;justify-content: space-between;">
              <a-affix :offsetTop="120" @change="change" style="display: flex;">
                <a-button class="btnc">审核</a-button>
                <a-button class="btnc">改价</a-button>
                <a-button class="btnc">子订单</a-button>
              </a-affix>
            </a-col>
            <a-col :span="18"></a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-tabs defaultActiveKey="1" @change="callback">
                <a-tab-pane tab="订单详情" key="1">
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">客户信息</label>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="客户姓名" defaultValue="锁安" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="联系方式" defaultValue="15894894895" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="期望上门时间" defaultValue="2019/11/21 10:29-11:00" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;"></a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="10" style="width: 560px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="客户地址" defaultValue="江苏省南京市雨花区花神大厦" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="客户要求" defaultValue="安装前联系" />
                      </div>
                    </a-col>
                    <a-col :span="5"></a-col>
                  </a-row>
                  <a-row style="margin: 15px 0px 5px 0px;">
                    <a-col :span="5" style="margin: 0px 0px 0px 22px;">
                      <a-row>
                        <a-col :span="5">
                          <label for="">包裹1</label>
                        </a-col>
                        <a-col :span="5">
                          <a-checkbox @change="onChangeImportant" class="imp">重要</a-checkbox>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递公司" defaultValue="申通快递" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递单号" defaultValue="15894894895" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递状态" defaultValue="待发货" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="包裹备注" defaultValue="锁体/锁芯" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin: 15px 0px 5px 0px;">
                    <a-col :span="5" style="margin: 0px 0px 0px 22px;">
                      <a-row>
                        <a-col :span="5">
                          <label for="">包裹2</label>
                        </a-col>
                        <a-col :span="5">
                          <a-checkbox @change="onChangeImportant" class="imp">重要</a-checkbox>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递公司" defaultValue="申通快递" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递单号" defaultValue="15894894895" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递状态" defaultValue="待发货" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="包裹备注" defaultValue="锁体/锁芯" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin: 15px 0px 5px 0px;">
                    <a-col :span="5" style="margin: 0px 0px 0px 22px;">
                      <a-row>
                        <a-col :span="5">
                          <label for="">包裹1</label>
                        </a-col>
                        <a-col :span="5">
                          <a-checkbox @change="onChangeImportant" class="imp">重要</a-checkbox>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递公司" defaultValue="申通快递" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递单号" defaultValue="15894894895" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递状态" defaultValue="待发货" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="包裹备注" defaultValue="锁体/锁芯" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin: 15px 0px 5px 0px;">
                    <a-col :span="5" style="margin: 0px 0px 0px 22px;">
                      <a-row>
                        <a-col :span="5">
                          <label for="">包裹3</label>
                        </a-col>
                        <a-col :span="5">
                          <a-checkbox @change="onChangeImportant" class="imp">重要</a-checkbox>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递公司" defaultValue="申通快递" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递单号" defaultValue="15894894895" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="快递状态" defaultValue="待发货" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="包裹备注" defaultValue="锁体/锁芯" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">订单信息</label>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="订单号" defaultValue="16165161616165151511" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="企业名称" defaultValue="南京迈特望" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="品牌" defaultValue="品牌1" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="建单人" defaultValue="王一" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="付款方式" defaultValue="客户自费" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="客户结算状态" defaultValue="未结算" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="自定义1" defaultValue="10221221212" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="原始单号" defaultValue="5516161612215" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="安装类别" defaultValue="智能锁" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="型号" defaultValue="型号1" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="建单时间" defaultValue="2019.11.12 16：00" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="企业结算周期" defaultValue="单结" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="结算时间" defaultValue="2019.11.12 15：02" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="自定义2" defaultValue="442" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="序列号" defaultValue="11146135135131" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="订单类型" defaultValue="安装单" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="购买渠道" defaultValue="淘宝" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="核销时间" defaultValue="2019.11.12 16：00" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="客户付款状态" defaultValue="未结算" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="最近介入" defaultValue="淘宝" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="自定义3" defaultValue="1423223" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="销单码" defaultValue="11146135135131" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="数量" defaultValue="1" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="信息来源" defaultValue="广告" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="订单完成时间" defaultValue="2019.11.12 16：00" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="付款时间" defaultValue="2019.11.12 15：02" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">师傅信息</label>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="师傅姓名" defaultValue="梁非凡" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="销单时间" defaultValue="2019.11.12 16：00" />
                      </div>
                    </a-col>
                    <a-col span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="联系方式" defaultValue="21321312" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="照片上传时间" defaultValue="2019.11.12 16：00" />
                      </div>
                    </a-col>
                    <a-col span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="接单时间" defaultValue="2019.11.12 16：00" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="结算时间" defaultValue="2019.11.12 16：00" />
                      </div>
                    </a-col>
                    <a-col span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="上门预约时间" defaultValue="2019.11.12 16：00" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="10" style="width: 1120px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input
                          disabled="disabled"
                          addonBefore="师傅备注"
                          defaultValue="安装前要检测；安装前要拍照；安装后要拍照"
                        />
                      </div>
                    </a-col>
                  </a-row>
                  <div class="clearfix" style="margin: 8px 0px 0px 22px;">
                    <a-upload
                      action="//jsonplaceholder.typicode.com/posts/"
                      listType="picture-card"
                      :fileList="fileList"
                      @preview="handlePreview"
                      @change="handleChange"
                    >
                      <div v-if="fileList.length < 3">
                        <a-icon type="plus" />
                        <div class="ant-upload-text">Upload</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                      <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
                  </div>
                  <a-row>
                    <a-col :span="10" style="width: 1120px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input
                          disabled="disabled"
                          addonBefore="订单备注"
                          defaultValue="安装前要检测；安装前要拍照；安装后要拍照"
                        />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">配件信息</label>
                    </a-col>
                  </a-row>
                  <div style="margin-top: 10px;">
                    <!--                    <a-button class="editable-add-btn" @click="handleAdd">Add</a-button>-->
                    <a-table bordered :dataSource="dataSource" :columns="columns">
                      <!--                      <template slot="name" slot-scope="text, record">-->
                      <!--                        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)"/>-->
                      <!--                      </template>-->
                      <template slot="operation" slot-scope="text, record">
                        <a-popconfirm
                          v-if="dataSource.length"
                          title="Sure to delete?"
                          @confirm="() => onDelete(record.key)"
                        >
                          <a href="javascript:;">Delete</a>
                        </a-popconfirm>
                      </template>
                    </a-table>
                  </div>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">安装信息</label>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="锁的颜色" defaultValue="曜岩黑" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="门开方向" defaultValue="左内开" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="导向片类型" defaultValue="直角双孔" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="门的材质" defaultValue="铁门" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="门框挡片尺寸" defaultValue="40*356" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="导向片尺寸" defaultValue="40*356" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="门的厚度" defaultValue="5cm" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="折边宽度" defaultValue="30" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="上下螺丝孔距" defaultValue="" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="门的边距" defaultValue="5cm" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="有无天地钩" defaultValue="无" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="左右螺丝孔距" defaultValue="" />
                      </div>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="24">
                      <a-row>
                        <a-col :span="20" style="display: flex;margin-left: 11px;">
                          <label style="margin-left: 14px">门照片</label>
                          <div class="clearfix" style="margin-top: 8px;display: flex;margin-left: 17px">
                            <a-upload
                              action="//jsonplaceholder.typicode.com/posts/"
                              listType="picture-card"
                              :fileListtwo="fileListtwo"
                              @preview="handlePreviewtwo"
                              @change="handleChangetwo"
                            >
                              <div v-if="fileListtwo.length < 3">
                                <a-icon type="plus" />
                                <div class="ant-upload-text">Upload</div>
                              </div>
                            </a-upload>
                            <a-modal :visible="previewVisibletwo" :footer="null" @cancel="handleCanceltwo">
                              <img alt="example" style="width: 100%" :src="previewImagetwo" />
                            </a-modal>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 10px;">
                    <a-col :span="24">
                      <a-row>
                        <a-col :span="20" style="display: flex;margin-left: 11px;">
                          <label style="margin-left: 14px">门视频</label>
                          <div class="clearfix" style="margin-top: 8px;display: flex;margin-left: 17px">
                            <a-upload
                              action="//jsonplaceholder.typicode.com/posts/"
                              listType="picture-card"
                              :fileListthree="fileListthree"
                              @preview="handlePreviewthree"
                              @change="handleChangethree"
                              type="file"
                              accept="video/*"
                            >
                              <div v-if="fileListthree.length < 3">
                                <a-icon type="plus" />
                                <div class="ant-upload-text">Upload</div>
                              </div>
                            </a-upload>
                            <a-modal :visible="previewVisiblethree" :footer="null" @cancel="handleCancelthree">
                              <img alt="example" style="width: 100%" :src="previewImagethree" />
                            </a-modal>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">关联订单</label>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 30px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;"> </a-col>
                  </a-row>
                  <div class="dorder" style="margin-top: 10px;">
                    <!--                    <a-button class="editable-add-btn" @click="handleAdd">Add</a-button>-->
                    <a-table bordered :dataSource="dataSourceorder" :columns="columnsorder">
                      <!--                      <template slot="name" slot-scope="text, record">-->
                      <!--                        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)"/>-->
                      <!--                      </template>-->
                      <!--                      <template slot="operation" slot-scope="text, record">-->
                      <!--                      </template>-->
                    </a-table>
                  </div>
                  <a-affix
                    class="scroll"
                    :offsetTop="45"
                    @change="changefix"
                    style="position: absolute;right: 20px;bottom: 20px;"
                  >
                    <a-button
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                      @click="toTop(step)"
                    >
                      <i class="iconfont ions">&#xe6a9;</i>
                      <p>回到顶部</p>
                    </a-button>
                  </a-affix>
                  <a-affix :offsetTop="90" @change="changefix" style="position: absolute;right: 20px;bottom: 100px;">
                    <a-button style="width: 110px;height: 40px;">取消</a-button>
                  </a-affix>
                  <a-affix :offsetTop="130" style="position: absolute;right: 20px;bottom: 140px">
                    <a-button @click="changefixSubmission" style="width: 110px;height: 40px;">提交</a-button>
                  </a-affix>
                  <a-affix :offsetTop="170" @change="changefix" style="position: absolute;right: 20px;bottom: 180px;">
                    <a-button style="width: 110px;height: 40px;">编辑</a-button>
                  </a-affix>
                  <a-affix :offsetTop="210" @change="changefix" style="position: absolute;right: 20px;bottom: 220px;">
                    <a-button style="width: 110px;height: 40px;">补单通知</a-button>
                  </a-affix>
                  <a-affix :offsetTop="250" @change="changefix" style="position: absolute;right: 20px;bottom: 260px;">
                    <a-button style="width: 110px;height: 40px;">加急订单</a-button>
                  </a-affix>
                  <a-affix :offsetTop="290" @change="changefix" style="position: absolute;right: 20px;bottom: 300px;">
                    <a-button style="width: 110px;height: 40px;">短信提醒</a-button>
                  </a-affix>
                  <a-affix :offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 340px;">
                    <a-button style="width: 110px;height: 40px;">普通订单</a-button>
                  </a-affix>
                  <a-affix :offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 380px;">
                    <a-button style="width: 110px;height: 40px;">是否跳过校验</a-button>
                  </a-affix>
                  <a-affix offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 430px;">
                    <div
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                    >
                      <i class="iconfont ions">&#xe6b3;</i>
                      <p>问题反馈1</p>
                    </div>
                  </a-affix>
                  <a-affix offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 512px;">
                    <div
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                    >
                      <i class="iconfont ions">&#xe651;</i>
                      <p>问题反馈</p>
                    </div>
                  </a-affix>
                </a-tab-pane>
                <a-tab-pane tab="金额信息" key="2">
                  <a-row style="margin-top: 10px;">
                    <a-col :span="5" style="width: 280px;margin: 0px 0px 0px 22px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="订单号" defaultValue="12321312" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="企业名称" defaultValue="南京迈特望" />
                      </div>
                      <div>
                        <a-input disabled="disabled" class="inps" addonBefore="企业总金额" defaultValue="666" />
                      </div>
                      <div>
                        <a-input disabled="disabled" class="inps" addonBefore="师傅总金额" defaultValue="233" />
                      </div>
                      <div>
                        <a-input disabled="disabled" class="inps" addonBefore="订单差额" defaultValue="33" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="安装类别" defaultValue="智能锁" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="企业负责人" defaultValue="张三" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="订单类型" defaultValue="安装单" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="师傅姓名" defaultValue="李四" />
                      </div>
                    </a-col>
                    <a-col :span="5" style="width: 280px;">
                      <div>
                        <a-input disabled="disabled" addonBefore="数量" defaultValue="2" />
                      </div>
                      <div>
                        <a-input disabled="disabled" addonBefore="联系方式" defaultValue="1643535" />
                      </div>
                    </a-col>
                  </a-row>
                  <div style="background-color: #FFB892;">
                    <a-row style="padding: 0px;">
                      <a-col :span="24" class="orderKeyword">
                        <span style="color: white;margin-left: 20px;">金额要求</span>
                      </a-col>
                    </a-row>
                    <div style="margin-left: 20px;">
                      <ul>
                        <li disabled="disabled" style="color: white;">
                          假锁随主锁安装80元/套；猫眼70/锁具自带50；远程费用根据实际情况申请
                        </li>
                      </ul>
                    </div>
                  </div>
                  <a-row style="margin-top: 30px;">
                    <a-col>
                      <label class="orderKeyword">企业金额</label>
                    </a-col>
                  </a-row>
                  <div class="money" style="margin-top: 10px;margin-left: 20px;">
                    <!--                    <a-button class="editable-add-btn" @click="handleAdd">Add</a-button>-->
                    <a-table bordered :dataSource="dataSourcemoney" :columns="columnsmoney">
                      <!--                      <template slot="name" slot-scope="text, record">-->
                      <!--                        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)"/>-->
                      <!--                      </template>-->
                      <template slot="operation" slot-scope="text, record">
                        <a-popconfirm
                          v-if="dataSource.length"
                          title="Sure to delete?"
                          @confirm="() => onDelete(record.key)"
                        >
                          <a href="javascript:;">Delete</a>
                        </a-popconfirm>
                      </template>
                    </a-table>
                  </div>
                  <a-row style="margin-top: 0px;">
                    <a-col>
                      <label class="orderKeyword">师傅金额</label>
                    </a-col>
                  </a-row>
                  <div class="money" style="margin-top: 10px;margin-left: 20px;">
                    <!--                    <a-button class="editable-add-btn" @click="handleAdd">Add</a-button>-->
                    <a-table bordered :dataSource="dataSourceworker" :columns="columnsworker">
                      <!--                      <template slot="name" slot-scope="text, record">-->
                      <!--                        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)"/>-->
                      <!--                      </template>-->
                      <template slot="operation" slot-scope="text, record">
                        <a-popconfirm
                          v-if="dataSource.length"
                          title="Sure to delete?"
                          @confirm="() => onDelete(record.key)"
                        >
                          <a href="javascript:;">Delete</a>
                        </a-popconfirm>
                      </template>
                    </a-table>
                  </div>
                  <a-row style="margin-top: 0px;">
                    <a-col>
                      <label class="orderKeyword">金额记录</label>
                    </a-col>
                  </a-row>
                  <div class="record" style="margin-top: 10px;margin-left: 20px;">
                    <!--                    <a-button class="editable-add-btn" @click="handleAdd">Add</a-button>-->
                    <a-table bordered :dataSource="dataSourcerecord" :columns="columnsrecord">
                      <!--                      <template slot="name" slot-scope="text, record">-->
                      <!--                        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)"/>-->
                      <!--                      </template>-->
                      <template slot="operation" slot-scope="text, record">
                        <a-popconfirm
                          v-if="dataSource.length"
                          title="Sure to delete?"
                          @confirm="() => onDelete(record.key)"
                        >
                          <a href="javascript:;">Delete</a>
                        </a-popconfirm>
                      </template>
                    </a-table>
                  </div>
                  <a-affix
                    class="scroll"
                    :offsetTop="45"
                    @change="changefix"
                    style="position: absolute;right: 20px;bottom: 20px;"
                  >
                    <a-button
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                      @click="toTop(step)"
                    >
                      <i class="iconfont ions">&#xe6a9;</i>
                      <p>回到顶部</p>
                    </a-button>
                  </a-affix>
                  <a-affix offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 100px;">
                    <div
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                    >
                      <i class="iconfont ions">&#xe6b3;</i>
                      <p>问题反馈1</p>
                    </div>
                  </a-affix>
                  <a-affix offsetTop="330" @change="changefix" style="position: absolute;right: 20px;bottom: 180px;">
                    <div
                      style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;"
                    >
                      <i class="iconfont ions">&#xe651;</i>
                      <p>问题反馈</p>
                    </div>
                  </a-affix>
                </a-tab-pane>
                <a-tab-pane tab="完工资料" key="3">Content of Tab Pane 3</a-tab-pane>
                <a-tab-pane tab="核销信息" key="4">Content of Tab Pane 4</a-tab-pane>
              </a-tabs>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
  </div>
</template>

<script>
import EditableCell from './EditableCell'
import '@/assets/iconfont/iconfont.css'

export default {
  name: 'OrderDetails',
  components: {
    EditableCell
  },
  props: {
    step: {
      // 此数据是控制动画快慢的
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      dataSourcerecord: [
        {
          key: '0',
          name: 'Edward King 0',
          age: '32',
          address: 'London, Park Lane no. 0'
        },
        {
          key: '1',
          name: 'Edward King 1',
          age: '32',
          address: 'London, Park Lane no. 1'
        }
      ],
      count: 2,
      columnsrecord: [
        {
          title: '序号',
          dataIndex: 'name',
          width: '20px'
        },
        {
          title: '提交步骤',
          dataIndex: 'age',
          width: '20px'
        },
        {
          title: '提交人',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '提交时间',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '角色',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '金额类型',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '数量',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '初始金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '修改金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '现订单金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '金额备注',
          width: '20px',
          dataIndex: 'address'
        }
      ],
      dataSourceworker: [
        {
          key: '0',
          name: 'Edward King 0',
          age: '32',
          address: 'London, Park Lane no. 0'
        },
        {
          key: '1',
          name: 'Edward King 1',
          age: '32',
          address: 'London, Park Lane no. 1'
        }
      ],
      columnsworker: [
        {
          title: '序号',
          dataIndex: 'name',
          width: '20px'
        },
        {
          title: '金额类型',
          dataIndex: 'age',
          width: '20px'
        },
        {
          title: '数量',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '初始单价',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '初始金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '修改金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '现订单金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '提交人',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '提交时间',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '金额备注',
          width: '20px',
          dataIndex: 'address'
        }
      ],
      dataSourcemoney: [
        {
          key: '0',
          name: 'Edward King 0',
          age: '32',
          address: 'London, Park Lane no. 0'
        },
        {
          key: '1',
          name: 'Edward King 1',
          age: '32',
          address: 'London, Park Lane no. 1'
        }
      ],
      columnsmoney: [
        {
          title: '序号',
          dataIndex: 'name',
          width: '20px'
        },
        {
          title: '金额类型',
          dataIndex: 'age',
          width: '20px'
        },
        {
          title: '数量',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '初始单价',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '初始金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '修改金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '现订单金额',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '提交人',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '提交时间',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '金额备注',
          width: '20px',
          dataIndex: 'address'
        }
      ],
      isActive: false,
      dataSourceorder: [
        {
          key: '0',
          name: 'Edward King 0',
          age: '32',
          address: 'London, Park Lane no. 0'
        },
        {
          key: '1',
          name: 'Edward King 1',
          age: '32',
          address: 'London, Park Lane no. 1'
        }
      ],
      columnsorder: [
        {
          title: '序号',
          dataIndex: 'name',
          width: '20px'
        },
        {
          title: '状态栏',
          dataIndex: 'age',
          width: '20px'
        },
        {
          title: '订单号',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '订单类型',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '订单状态',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '企业名称',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '品牌型号',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '客户姓名',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '师傅姓名',
          width: '20px',
          dataIndex: 'address'
        }
      ],
      headers: {
        authorization: 'authorization-text'
      },
      dataSource: [
        {
          key: '0',
          name: 'Edward King 0',
          age: '32',
          address: 'London, Park Lane no. 0'
        },
        {
          key: '1',
          name: 'Edward King 1',
          age: '32',
          address: 'London, Park Lane no. 1'
        }
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'name',
          width: '20px',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '60px',
          scopedSlots: { customRender: 'operation' }
        },
        {
          title: '配件名称',
          width: '20px',
          dataIndex: 'age'
        },
        {
          title: '配件类型',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '配件型号',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '配件规格',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '数量',
          width: '15px',
          dataIndex: 'address'
        },
        {
          title: '配件总金额',
          width: '25px',
          dataIndex: 'address'
        },
        {
          title: '发货日期',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '快递公司',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '快递单号',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '快递状态',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '发货仓库',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '发货人',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '收货人',
          width: '20px',
          dataIndex: 'address'
        },
        {
          title: '备注',
          width: '20px',
          dataIndex: 'address'
        }
      ],
      // 上传1
      previewVisible: false,
      previewImage: '',
      fileList: [
        {
          // uid: '-1',
          // name: 'xxx.png',
          // status: 'done',
          // url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        }
      ],
      // 以上上传1
      // 上传2
      previewVisibletwo: false,
      previewImagetwo: '',
      fileListtwo: [
        {
          // uid: '-1',
          // name: 'xxx.png',
          // status: 'done',
          // url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        }
      ],
      // 以上上传2
      // 上传3
      previewVisiblethree: false,
      previewImagethree: '',
      fileListthree: [
        {
          // uid: '-1',
          // name: 'xxx.png',
          // status: 'done',
          // url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        }
      ]
      // 以上上传3
    }
  },
  methods: {
    toTop(i) {
      // 参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop -= i
      if (document.documentElement.scrollTop > 0) {
        var c = setTimeout(() => this.toTop(i), 16)
      } else {
        clearTimeout(c)
      }
    },
    // handleChange(info) {
    //   if (info.file.status !== 'uploading') {
    //     console.log(info.file, info.fileList)
    //   }
    //   if (info.file.status === 'done') {
    //     this.$message.success(`${info.file.name} file uploaded successfully`)
    //   } else if (info.file.status === 'error') {
    //     this.$message.error(`${info.file.name} file upload failed.`)
    //   }
    // },
    // onCellChange (key, dataIndex, value) {
    //   const dataSource = [...this.dataSource]
    //   const target = dataSource.find(item => item.key === key)
    //   if (target) {
    //     target[dataIndex] = value
    //     this.dataSource = dataSource
    //   }
    // },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
    },
    // handleAdd () {
    //   const { count, dataSource } = this
    //   const newData = {
    //     key: count,
    //     name: `Edward King ${count}`,
    //     age: 32,
    //     address: `London, Park Lane no. ${count}`
    //   }
    //   this.dataSource = [...dataSource, newData]
    //   this.count = count + 1
    // },
    // 上传1
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
      // 在里面调禁用的接口
    },
    handleChange({ fileList }) {
      this.fileList = fileList
    },
    // 上传2
    handleCanceltwo() {
      this.previewVisibletwo = false
    },
    handlePreviewtwo(file) {
      this.previewImagetwo = file.url || file.thumbUrl
      this.previewVisibletwo = true
      // 在里面调禁用的接口
    },
    handleChangetwo({ fileListtwo }) {
      this.fileListtwo = fileListtwo
    },
    // 上传3
    handleCancelthree() {
      this.previewVisiblethree = false
    },
    handlePreviewthree(file) {
      this.previewImagethree = file.url || file.thumbUrl
      this.previewVisiblethree = true
      // 在里面调禁用的接口
    },
    handleChangethree({ fileListthree }) {
      this.fileListthree = fileListthree
    }
  }
}
</script>

<style scoped>
.btnc {
  background-color: #53b0fe;
  color: white;
  width: 90px;
  border-radius: 10px;
}
.orderKeyword {
  font-family: 黑体;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0px 0px 0px;
}
.imp >>> .ant-checkbox-inner {
  width: 20px;
  height: 20px;
  border-radius: 20px;
}
/deep/ .ant-checkbox-inner::after {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
/deep/ .dorder .ant-table-body {
  width: 1200px;
}
/deep/ .ant-input-group-addon {
  width: 110px;
}
/deep/ .inps .ant-input-group-addon:first-child {
  background-color: #ff8587;
  color: white;
}
/deep/ .money .ant-table-body {
  width: 1100px;
}
/deep/ .record .ant-table-body {
  width: 1200px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
